import { useAuthStore } from '@/stores/auth.store'

interface LoggerOptions {
  context?: string
  [key: string]: unknown
}

class Logger {
  private static instance: Logger

  private constructor() {}

  static getInstance(): Logger {
    if (!Logger.instance) {
      Logger.instance = new Logger()
    }
    return Logger.instance
  }

  private shouldLog(): boolean {
    const perfil = useAuthStore.getState().perfil
    return perfil?.log_debug ?? false
  }

  log(message: unknown, options: LoggerOptions = {}): void {
    if (!this.shouldLog()) return

    const { context } = options
    const timestamp = new Date().toISOString()
    const contextStr = context ? `[${context}]` : ''
    console.log(`${timestamp} ${contextStr}`, message)
  }

  info(message: unknown, options: LoggerOptions = {}): void {
    this.log(message, { ...options, context: options.context || 'INFO' })
  }

  debug(message: unknown, options: LoggerOptions = {}): void {
    this.log(message, { ...options, context: options.context || 'DEBUG' })
  }

  warn(message: unknown, options: LoggerOptions = {}): void {
    this.log(message, { ...options, context: options.context || 'WARN' })
  }

  error(message: unknown, options: LoggerOptions = {}): void {
    this.log(message, { ...options, context: options.context || 'ERROR' })
  }
}

// Exportar instância singleton
export const logger = Logger.getInstance()

// Exportar classe para casos especiais
export { Logger }
